
import React, { useState, useEffect } from "react";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Col, Row, Card, Form, Button, InputGroup, ButtonGroup } from '@themesberg/react-bootstrap';
import { addVehicleMake, getVehicleMakes, getVehicleModels, addVehicleModel, getFuelTypes, addVehicle } from "../api/services/vehicleService";


export const GeneralInfoForm = () => {
  const [birthday, setBirthday] = useState("");

  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">General information</h5>
        <Form>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="firstName">
                <Form.Label>First Name</Form.Label>
                <Form.Control required type="text" placeholder="Enter your first name" />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="lastName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control required type="text" placeholder="Also your last name" />
              </Form.Group>
            </Col>
          </Row>
          <Row className="align-items-center">
            <Col md={6} className="mb-3">
              <Form.Group id="birthday">
                <Form.Label>Birthday</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={setBirthday}
                  renderInput={(props, openCalendar) => (
                    <InputGroup>
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        value={birthday ? moment(birthday).format("MM/DD/YYYY") : ""}
                        placeholder="mm/dd/yyyy"
                        onFocus={openCalendar}
                        onChange={() => { }} />
                    </InputGroup>
                  )} />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="gender">
                <Form.Label>Gender</Form.Label>
                <Form.Select defaultValue="0">
                  <option value="0">Gender</option>
                  <option value="1">Female</option>
                  <option value="2">Male</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="emal">
                <Form.Label>Email</Form.Label>
                <Form.Control required type="email" placeholder="name@company.com" />
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="phone">
                <Form.Label>Phone</Form.Label>
                <Form.Control required type="number" placeholder="+12-345 678 910" />
              </Form.Group>
            </Col>
          </Row>

          <h5 className="my-4">Address</h5>
          <Row>
            <Col sm={9} className="mb-3">
              <Form.Group id="address">
                <Form.Label>Address</Form.Label>
                <Form.Control required type="text" placeholder="Enter your home address" />
              </Form.Group>
            </Col>
            <Col sm={3} className="mb-3">
              <Form.Group id="addressNumber">
                <Form.Label>Number</Form.Label>
                <Form.Control required type="number" placeholder="No." />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col sm={4} className="mb-3">
              <Form.Group id="city">
                <Form.Label>City</Form.Label>
                <Form.Control required type="text" placeholder="City" />
              </Form.Group>
            </Col>
            <Col sm={4} className="mb-3">
              <Form.Group className="mb-2">
                <Form.Label>Select state</Form.Label>
                <Form.Select id="state" defaultValue="0">
                  <option value="0">State</option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col sm={4}>
              <Form.Group id="zip">
                <Form.Label>ZIP</Form.Label>
                <Form.Control required type="tel" placeholder="ZIP" />
              </Form.Group>
            </Col>
          </Row>
          <div className="mt-3">
            <Button variant="primary" type="submit">Save All</Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};

export const VehicleAddForm = ({ form, setForm }) => {
  // const [birthday, setBirthday] = useState("");

  const [registrationNumber, setRegistrationNumber] = useState("");
  const [registrationExpiryDate, setRegistrationExpiryDate] = useState("");
  const [registrationIssueDate, setRegistrationIssueDate] = useState("");

  const [vehicleType, setVehicleType] = useState("");
  const [selectedFuelType, setSelectedFuelType] = useState("");

  const [capacity, setCapacity] = useState("");
  const [volume, setVolume] = useState("");
  const [length, setLength] = useState("");
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");

  const [bodyType, setBodyType] = useState("");
  const [ownerType, setOwnerType] = useState("");
  const [vendorName, setVendorName] = useState("");

  const [pollutionNumber, setPollutionNumber] = useState("");
  const [pollutionIssueDate, setPollutionIssueDate] = useState("");
  const [pollutionExpiryDate, setPollutionExpiryDate] = useState("");

  const [insuranceNumber, setInsuranceNumber] = useState("");
  const [insuranceIssueDate, setInsuranceIssueDate] = useState("");
  const [insuranceExpiryDate, setInsuranceExpiryDate] = useState("");
  const [selectedMake, setSelectedMake] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  
  const [makes, setMakes] = useState([]);
  const [fuelTypes, setFuelTypes] = useState([]);
  const [models, setModels] = useState([]);

  useEffect(() => {
    fetchMakes();
    fetchFuelTypes();
  }, []);

  useEffect(() => {
    if (selectedMake) {
      fetchModels(selectedMake);
      setSelectedModel(""); // 🔥 reset model
    } else {
      setModels([]);        // clear models if no make
      setSelectedModel("");
    }
  }, [selectedMake]);

  const fetchMakes = async () => {
    try {
      const data = await getVehicleMakes(); console.log("Fetched makes:", data);  // 👈 IMPORTANT
      setMakes(data);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchModels = async (makerId) => {
    try {
      const data = await getVehicleModels(makerId);
      setModels(data);
    } catch (error) {
      console.error("Error fetching models:", error);
    }
  };

  const fetchFuelTypes = async () => {
    try {
      const data = await getFuelTypes();
      setFuelTypes(data);
      console.log("Fetched fuel types:", data);
    }
    catch (error) {
      console.error("Error fetching fuel types:", error);
    }
  };

  const handleVehicleTypeChange =(value) => {
    setForm(value);
  };
  const handleAddModel = async () => {
    let newModel = prompt("Enter vehicle model");

    if (!newModel || !selectedMake) {
      alert("Select make first!");
      return;
    }

    newModel = newModel.trim().toLowerCase();

    // prevent duplicate in UI
    if (models.some(m => m.model_name.toLowerCase() === newModel)) {
      alert("Model already exists!");
      return;
    }

    try {
      const data = await addVehicleModel({
        maker: selectedMake,   // 🔥 IMPORTANT (ID)
        model_name: newModel
      });

      console.log("Model added:", data);

      // update UI
      setModels(prev => [...prev, data]);

      alert("Model added successfully");

    } catch (error) {
      console.error("Error:", error.response?.data);

      const errMsg =
        error.response?.data?.model_name?.[0] ||
        error.response?.data?.error ||
        "Error adding model";

      alert(errMsg);
    }
  };


  const handleAddMake = async () => {
    let newMake = prompt("Enter new vehicle make Name");

    if (!newMake) return;

    newMake = newMake.trim().toLowerCase();

    try {
      const data = await addVehicleMake({ vehicle_make: newMake });

      console.log("Success:", data);

      // ✅ update UI AFTER success
      setMakes(prev => [...prev, data.vehicle_make]);

      alert("Vehicle make added successfully");

    } catch (error) {
      console.error("Error:", error.response?.data);

      // ✅ show backend error properly
      const errMsg =
        error.response?.data?.vehicle_make?.[0] ||
        error.response?.data?.error ||
        "Make already exists or invalid";

      alert(errMsg);
    }
  };

  const handleAddVehicle = async () => {
    // if (!registrationNumber || !registrationExpiryDate || !registrationIssueDate) {
    //   alert("Please fill required fields");
    //   return;
    // }

    try {
      const payload = {
        vehicle_number: registrationNumber,
        registration_issue_date: registrationIssueDate ? moment(registrationIssueDate).format("YYYY-MM-DD") : null,
        registration_expiry_date: registrationExpiryDate ? moment(registrationExpiryDate).format("YYYY-MM-DD") : null,
        vehicle_type: Number(vehicleType),
        fuel_type: Number(selectedFuelType),

        load_capacity: capacity ? Number(capacity) : null,
        volume: volume ? Number(volume) : 0,
        length: length ? Number(length) : 0,
        width: width ? Number(width) : 0,
        height: height ? Number(height) : 0,

        body_type: 0,
        owner_type: Number(ownerType),
        owner_name: vendorName,
        pollution_number: pollutionNumber,
        pollution_issue_date: pollutionIssueDate ? moment(pollutionIssueDate).format("YYYY-MM-DD") : null,
        pollution_expiry_date: pollutionExpiryDate ? moment(pollutionExpiryDate).format("YYYY-MM-DD") : null,
        insurance_number: insuranceNumber,
        insurance_issue_date: insuranceIssueDate ? moment(insuranceIssueDate).format("YYYY-MM-DD") : null,
        insurance_expiry_date: insuranceExpiryDate ? moment(insuranceExpiryDate).format("YYYY-MM-DD") : null,
        
        vehicle_maker: selectedMake || null,   // 🔥 ID
        vehicle_model: selectedModel || null   // 🔥 ID
      };

      console.log("Payload:", payload);

      const data = await addVehicle(payload);

      console.log("Vehicle Added:", data);

      alert("Vehicle added successfully ✅");

      // // 🔥 reset form
      setRegistrationNumber("");
      setRegistrationExpiryDate("");
      setRegistrationIssueDate("");
      setVolume("");
      setLength("");
      setWidth("");
      setHeight("");
      setVehicleType("");
      setSelectedFuelType("");
      setCapacity("");
      setSelectedMake("");
      setSelectedModel("");

    } catch (error) {
      console.error("Error:", error.response?.data);

      const errMsg =
        error.response?.data?.vehicle_number?.[0] ||
        error.response?.data?.error ||
        "Error adding vehicle";

      alert(errMsg);
    }
  };


  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <h5 className="mb-4">Vehicle information</h5>
        <Form>
          <Row className="align-items-center">
            <Col md={5} className="mb-3">
              <Form.Group id="RegistrationNumber">
                <Form.Label>Registration Number</Form.Label>
                <Form.Control required type="text" placeholder="Enter registration number" onChange={(e) => setRegistrationNumber(e.target.value)}/>
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3">
              <Form.Group id="registrationIssueDate">
                <Form.Label>Registration Issue</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={setRegistrationIssueDate}
                  renderInput={(props, openCalendar) => (
                    <InputGroup>
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        value={registrationIssueDate ? moment(registrationIssueDate).format("DD/MM/YYYY") : ""}
                        placeholder="DD/MM/YYYY"
                        onFocus={openCalendar}
                        onChange={(e) => setRegistrationIssueDate(e.target.value)} />
                    </InputGroup>
                  )} />
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3">
              <Form.Group id="registrationExpiryDate">
                <Form.Label>Registration Expiry</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={setRegistrationExpiryDate}
                  renderInput={(props, openCalendar) => (
                    <InputGroup>
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        value={registrationExpiryDate ? moment(registrationExpiryDate).format("DD/MM/YYYY") : ""}
                        placeholder="DD/MM/YYYY"
                        onFocus={openCalendar}
                        onChange={(e) => setRegistrationExpiryDate(e.target.value)} />
                    </InputGroup>
                  )} />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group id="vehicleType">
                <Form.Label>Vehicle Type *</Form.Label>
                <Form.Select defaultValue="0" onChange={(e) => {
                                                                const value = e.target.value;
                                                                setForm((prev) => ({
                                                                ...prev,
                                                                vehicleType: value
                                                              }));
                                                              setVehicleType(e.target.value)}}>
                  <option value="0">Select Vehicle Type</option>
                  <option value="1">Open Body</option>
                  <option value="2">Closed Body</option>
                  {/* <option value="3">Medium Truck</option>
                  <option value="4">Heavy Truck</option>
                  <option value="5">Trailer / Multi-Axle</option>
                  <option value="6">Reefer Truck</option>
                  <option value="7">Tanker</option>
                  <option value="8">Pickup</option> */}
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6} className="mb-3">
              <Form.Group id="gender">
                <Form.Label>Fuel Type *</Form.Label>
                <Form.Select
                  value={selectedFuelType}
                  onChange={(e) => setSelectedFuelType(e.target.value)}
                >
                  <option value="">Select Fuel Type</option>

                  {fuelTypes.map((fuelType) => (
                    <option key={fuelType.id} value={fuelType.id}>
                      {fuelType.name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>


          <Row className="align-items-center">
            {/* MAKE */}
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>
                  Vehicle Make *
                  <Button variant="outline-primary" size="sm" className="d-none d-sm-inline ms-2"
                    onClick={handleAddMake}>+ Add</Button>
                </Form.Label>

                <Form.Select
                  value={selectedMake}
                  onChange={(e) => setSelectedMake(e.target.value)}
                >
                  <option value="">Select Vehicle Make</option>

                  {makes.map((make) => (
                    <option key={make.id} value={make.id}>
                      {make.vehicle_make.toUpperCase()}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>

            {/* MODEL */}
            <Col md={6} className="mb-3">
              <Form.Group>
                <Form.Label>
                  Vehicle Category *
                  <Button variant="outline-primary" size="sm" className="d-none d-sm-inline ms-2"
                    onClick={handleAddModel}>+ Add</Button>
                </Form.Label>

                <Form.Select
                  value={selectedModel}
                  onChange={(e) => setSelectedModel(e.target.value)}
                  disabled={!selectedMake}   // 🔥 important
                >
                  <option value="">Select Vehicle Model</option>

                  {models.map((model) => (
                    <option key={model.id} value={model.id}>
                      {model.model_name}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>

          <h5 className="my-4">Capacity</h5>
          <Row>
            <Col sm={4} className="mb-3">
              <Form.Group id="loadCapacity">
                <Form.Label>Load Capacity * (In Tons) </Form.Label>
                <Form.Control required type="number" placeholder="Enter load capacity" onChange={(e) => setCapacity(e.target.value)}/>
              </Form.Group>
            </Col>
            {/* <Col sm={4} className="mb-3">
              <Form.Group id="volume">
                <Form.Label>Volume *</Form.Label>
                <Form.Control required type="number" placeholder="Volume" onChange={(e) => setVolume(e.target.value)} />
              </Form.Group>
            </Col> */}
            {/* <Col md={4} className="mb-3">
              <Form.Group id="vehicleType">
                <Form.Label>Body Type *</Form.Label>
                <Form.Select defaultValue="0"  onChange={(e) => setBodyType(e.target.value)}>
                  <option value="0">Select Body Type</option>
                  <option value="1">OPEN</option>
                  <option value="2">CONTAINER</option>
                  <option value="3">HALF_BODY</option>
                  <option value="4">TANKER</option>
                  <option value="5">REEFER</option>
                  <option value="6">TRAILER</option>
                  <option value="7">FLATBED</option>
                  <option value="8">TIPPER</option>
                  <option value="9">HIGH_DECK</option>
                  <option value="10">LOW_DECK</option>
                </Form.Select>
              </Form.Group>
            </Col> */}
          </Row>
          <Row>
            {/* <Col sm={4} className="mb-3">
              <Form.Group id="Length">
                <Form.Label>Length *</Form.Label>
                <Form.Control required type="number" placeholder="Length" value={form.capacity.dimensions.length} onChange={(e) =>{ handleDimensionChange("length", e.target.value); setLength(e.target.value);}} />
              </Form.Group>
            </Col> */}

            {/* <Col sm={4} className="mb-3">
              <Form.Group id="Width">
                <Form.Label>Width *</Form.Label>
                <Form.Control required type="number" placeholder="Width" value={form.capacity.dimensions.width} onChange={(e) =>{ handleDimensionChange("width", e.target.value); setWidth(e.target.value);}} />
              </Form.Group>
            </Col> */}

            {/* <Col sm={4} className="mb-3">
              <Form.Group id="Height">
                <Form.Label>Height *</Form.Label>
                <Form.Control required type="number" placeholder="Height" value={form.capacity.dimensions.height} onChange={(e) =>{ handleDimensionChange("height", e.target.value); setHeight(e.target.value);}} />
              </Form.Group>
            </Col> */}
          </Row>
          <h5 className="my-4">Owner Information</h5>
          <Row className="align-items-center">
            <Col md={6} className="mb-3">
              <Form.Group id="gender">
                <Form.Label>Owner Type *</Form.Label>
                <Form.Select defaultValue="0" onChange={(e) => setOwnerType(e.target.value)}>
                  <option value="0">Select Owner Type</option>
                  <option value="1">Self</option>
                  <option value="2">Adhoc</option>
                </Form.Select>
              </Form.Group>
            </Col>

            <Col md={6} className="mb-3">
              <Form.Group id="email">
                <Form.Label>Vendor Name</Form.Label>
                <Form.Control required type="text" placeholder="Enter vendor name" onChange={(e) => setVendorName(e.target.value)} />
              </Form.Group>
            </Col>
          </Row>

          <h5 className="my-4">Documents Information</h5>
          

          <Row className="align-items-center">
            <Col md={5} className="mb-3">
              <Form.Group id="PollutionNumber">
                <Form.Label>Pollution Number</Form.Label>
                <Form.Control required type="text" placeholder="Enter pollution number" onChange={(e) => setPollutionNumber(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3">
              <Form.Group id="pollutionIssueDate">
                <Form.Label>Pollution Issue</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={(date) => setPollutionIssueDate(date)}
                  renderInput={(props, openCalendar) => (
                    <InputGroup>
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        value={pollutionIssueDate ? moment(pollutionIssueDate).format("DD/MM/YYYY") : ""}
                        placeholder="DD/MM/YYYY"
                        onFocus={openCalendar}
                        onChange={() => { }} />
                    </InputGroup>
                  )} />
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3">
              <Form.Group id="pollutionExpiryDate">
                <Form.Label>Pollution Expiry</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={(date) => setPollutionExpiryDate(date)}
                  renderInput={(props, openCalendar) => (
                    <InputGroup>
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        value={pollutionExpiryDate ? moment(pollutionExpiryDate).format("DD/MM/YYYY") : ""}
                        placeholder="DD/MM/YYYY"
                        onFocus={openCalendar}
                        onChange={() => { }} />
                    </InputGroup>
                  )} />
              </Form.Group>
            </Col>
          </Row>

          <Row className="align-items-center">
            <Col md={5} className="mb-3">
              <Form.Group id="InsuranceNumber">
                <Form.Label>Insurance Number</Form.Label>
                <Form.Control required type="text" placeholder="Enter insurance number" onChange={(e) => setInsuranceNumber(e.target.value)} />
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3">
              <Form.Group id="insuranceIssueDate">
                <Form.Label>Insurance Issue</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={(date) => setInsuranceIssueDate(date)}
                  renderInput={(props, openCalendar) => (
                    <InputGroup>
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        value={insuranceIssueDate ? moment(insuranceIssueDate).format("DD/MM/YYYY") : ""}
                        placeholder="DD/MM/YYYY"
                        onFocus={openCalendar}
                        onChange={() => { }} />
                    </InputGroup>
                  )} />
              </Form.Group>
            </Col>
            <Col md={3} className="mb-3">
              <Form.Group id="insuranceExpiryDate">
                <Form.Label>Insurance Expiry</Form.Label>
                <Datetime
                  timeFormat={false}
                  onChange={(date) => setInsuranceExpiryDate(date)}
                  renderInput={(props, openCalendar) => (
                    <InputGroup>
                      <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                      <Form.Control
                        required
                        type="text"
                        value={insuranceExpiryDate ? moment(insuranceExpiryDate).format("DD/MM/YYYY") : ""}
                        placeholder="DD/MM/YYYY"
                        onFocus={openCalendar}
                        onChange={() => { }} />
                    </InputGroup>
                  )} />
              </Form.Group>
            </Col>
          </Row>

          <div className="text-center mt-3">
            <Button variant="primary" type="submit" onClick={handleAddVehicle}>Save All</Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
}
